module.exports = __webpack_public_path__ + "img/Scout.f92b6420.png";